<template>
    <div>
        <loader :show="enviando"/>
        <v-card>
            <v-toolbar>
                <v-btn icon class="hidden-xs-only" @click="$router.go(-1)">
                    <v-icon>arrow_back</v-icon>
                </v-btn>
                <v-toolbar-title>{{horario.nombre}}</v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>

            <personalizado
                v-if="horario.tipo == 'Personalizado'"
                :id="id"
                :horario="horario.personalizado"
                :dependencias="horario.dependencias"
                :puestos="horario.puestos"
                @horaAgregadaPersonalizado="horaAgregadaPersonalizado"
                @horaEliminadaPersonalizado="horaEliminadaPersonalizado"
                @toleranciaPersonalizada="toleranciaPersonalizada"
                @dependenciaAgregada="dependenciaAgregada"
                @dependenciaEliminada="dependenciaEliminada"
                @puestoAgregado="puestoAgregado"
                @puestoEliminado="puestoEliminado"
                @enviandoStart="enviando=true"
                @enviandoStop="enviando=false"
            />
            <dinamico
                v-else
                :id="id"
                :horario="horario.dinamico"
                :dependencias="horario.dependencias"
                :puestos="horario.puestos"
                @fechaBaseModificada="fechaBaseModificada"
                @toleranciaDinamico="toleranciaDinamico"
                @dependenciaAgregada="dependenciaAgregada"
                @dependenciaEliminada="dependenciaEliminada"
                @puestoAgregado="puestoAgregado"
                @puestoEliminado="puestoEliminado"
                @enviandoStart="enviando=true"
                @enviandoStop="enviando=false"
            />

        </v-card>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import Loader from '../../components/Loader'
import axios from 'axios'
import moment from 'moment'

import Personalizado from './personalizado'
import Dinamico from './dinamico'

export default {
    name: 'ConsultarHorario',
	components: {
        Loader,
        Personalizado,
        Dinamico
	},
    computed: {
        ...mapGetters([
            "sessionToken",
            "httpURL",
            "userId",
        ])
    },
    data() {
        return {
            id: this.$route.params.id,
            enviando: false,
            cardColor: 'blue lighten-1',
            horario: {
                personalizado:{
                    tolerancia: { entrada:{},salida:{}},
                    lunes:[],martes:[],miercoles:[],jueves:[],viernes:[],sabado:[],domingo:[],
                },
                dinamico:{
                    tolerancia: { entrada:{},salida:{}}
                },
                dependencias:[],
                puestos:[]
            }
        }
    },
    created(){
        this.enviando = true;
        axios.get(this.httpURL+'/horarios/consultar/'+this.id,{headers:{token: this.sessionToken}})
            .then(res => {
                // console.log(res);
                // let personal = [];
                this.horario = res.data.horario;
                this.enviando = false;
                this.$notify({ group: 'foo_notif', type:'success', duration:3500, text: res.data.mensaje});
            })
            .catch(error => {
                // console.log(error);
                this.enviando = false;
                this.$notify({ group: 'foo_notif', type:'error', duration:4000, text: error.response.data.mensaje});
            });
    },
    methods:{
        horaAgregadaPersonalizado(dia,hora){
            this.horario.personalizado[dia].push(hora);
        },
        horaEliminadaPersonalizado(dia,id){
            let index = this.horario.personalizado[dia].findIndex(x=>x._id == id);
            this.horario.personalizado[dia].splice(index,1);
        },
        toleranciaPersonalizada(entrada,salida){
            this.horario.personalizado.tolerancia.entrada = entrada;
            this.horario.personalizado.tolerancia.salida = salida;
        },
        dependenciaAgregada(payload){
            this.horario.dependencias.push(payload);
        },
        dependenciaEliminada(payload){
            // console.log(payload);
            let index = this.horario.dependencias.findIndex(x=>x._id == payload.id);
            // console.log(index);
            this.horario.dependencias.splice(index,1);
        },
        puestoAgregado(payload){
            this.horario.puestos.push(payload);
        },
        puestoEliminado(payload){
            // console.log(payload);
            let index = this.horario.puestos.findIndex(x=>x._id == payload.id);
            // console.log(index);
            this.horario.puestos.splice(index,1);
        },
        toleranciaDinamico(entrada,salida){
            this.horario.dinamico.tolerancia.entrada = entrada;
            this.horario.dinamico.tolerancia.salida = salida;
        },
        fechaBaseModificada(fecha){
            this.horario.dinamico.fechaCalculo = fecha;
        }
    }
}
</script>